<mat-card class="non-owner-personnel-card" data-cy="non-owner-personnel-card">
  <mat-card-header>
    <div class="non-owner-personnel-card-name">
      <span data-cy="non-owner-personnel-name">{{ nonOwnerPersonnel.first }} {{ nonOwnerPersonnel.last }}</span>
      <span>&nbsp;(Contact)</span>
    </div>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="form">
      <formly-form
        [form]="form"
        [fields]="fields"
        [model]="model"
        [options]="options">
      </formly-form>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <div class="nop-delete-buttons">
      <button
        data-cy="edit-non-owner-personnel-dialog-delete-button"
        color="warn"
        class="nop-delete-button"
        [disabled]="processing.saving"
        mat-flat-button
        *ngIf="!confirmDelete"
        (click)="confirmDelete = !confirmDelete">
        <mat-icon>delete_outline</mat-icon>
      </button>
      <button
        data-cy="edit-non-owner-personnel-dialog-cancel-delete-button"
        mat-button
        *ngIf="confirmDelete"
        (click)="confirmDelete = !confirmDelete">
        Cancel
      </button>
      <button
        data-cy="edit-non-owner-personnel-dialog-confirm-delete-button"
        [disabled]="processing.saving"
        mat-flat-button
        color="warn"
        *ngIf="confirmDelete"
        (click)="delete(nonOwnerPersonnel.id)">
        Confirm
      </button>
    </div>
    <div class="nop-edit-buttons">
      <button
        *ngIf="form.dirty && !processing.saving "
        mat-button
        (click)="cancelEdit()"
        class="nop-cancel-edit"
        [disabled]="processing.saving">
        Cancel
      </button>
      <button
        mat-flat-button
        color="primary"
        (click)="save()"
        [disabled]="!form.dirty || !form.valid || processing.saving">
        <mat-spinner
          *ngIf="showLoadingSpinner()"
          diameter="24"
          class="nop-spinny-spinner"
          >
        </mat-spinner>
        <span *ngIf="showSaveText()">
          Save
        </span>
      </button>
    </div>
  </mat-card-actions>
</mat-card>
